import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  InstallationUpsertedReponse,
  NedapInstallation,
  NedapInstallationsResponse,
  ResolveAuthorizationCode,
  UpdateNedapInstallationMetaDataRequest,
  UpdateNedapInstallationMetaDataResponse,
} from '../models/third-parties.model';

@Injectable({
  providedIn: 'root',
})
export class NedapIntegrationService {
  private secureBaseUrl = `${this.env.API_BASE_URL}/service/nedap-integration/secure/installation`;
  private insecureBaseUrl = `${this.env.API_BASE_URL}/service/nedap-integration/installation`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  getInstallations(): Observable<NedapInstallation[] | HttpErrorResponse> {
    return this.http.get<NedapInstallationsResponse>(`${this.secureBaseUrl}`).pipe(
      map((response: NedapInstallationsResponse) => response.installations),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<NedapInstallation[]>[]);
        } else {
          return throwError(() => ({ message: error.message }));
        }
      }),
    );
  }

  updateNedapInstallationMetaData(
    nedapInstallation: UpdateNedapInstallationMetaDataRequest,
  ): Observable<UpdateNedapInstallationMetaDataResponse> {
    return this.http.put<UpdateNedapInstallationMetaDataResponse>(
      this.secureBaseUrl,
      nedapInstallation,
      {},
    );
  }

  resolveAuthorizationCode(
    request: ResolveAuthorizationCode,
  ): Observable<InstallationUpsertedReponse | HttpErrorResponse> {
    return this.http.post<InstallationUpsertedReponse>(
      `${this.insecureBaseUrl}/authorization-code`,
      request,
    );
  }
}
